import { render, staticRenderFns } from "./OrderDetailsEdit.vue?vue&type=template&id=be149f22"
import script from "./OrderDetailsEdit.vue?vue&type=script&lang=js"
export * from "./OrderDetailsEdit.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailsEdit.vue?vue&type=style&index=0&id=be149f22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports